<template>
  <div>
    <hr v-if="exiberLinha" />
    <div :class="classTitulo" :style="color">{{ titulo }}</div>
  </div>
</template>

<script>
import { useConfiguracoesInteresseStore } from "@/store/configuracaoInicial";
import { storeToRefs } from "pinia";

export default {
  setup() {
    const { configuracoesInteresse } =
      storeToRefs(useConfiguracoesInteresseStore());
    return { configuracoesInteresse };
  },

  name: "TituloComponent",

  props: {
    exiberLinha: {
      type: Boolean,
      default: true,
    },
    classTitulo: {
      type: String,
      default: "text-center",
    },
    titulo: {
      type: String,
      default: "",
    },
  },

  computed: {
    color() {
      return 'color:rgb(' + this.configuracoesInteresse.configuracao.corTitulo + ') !important';
    },
  },
};
</script>
